import { css } from '@/styled-system/css';

export const photoCarouselRootStyles = css.raw({
  'display': 'flex',
  'position': 'relative',
  'flex': 1,
  'flexDirection': 'column',
  'width': '100%',
  'height': '100%',
  'overflow': 'hidden',

  '& > [data-c11n-component="Anchor"]': {
    height: '100%',
  },

  // Only show nav buttons to mouse users
  '& > [data-c11n-component="PhotoCarousel.NavControls"]': {
    display: 'flex',
    opacity: 0,
    // Use same transition timing as Property Card body's box-shadow
    transitionProperty: 'opacity',
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '0.2s',
    },
    transitionTimingFunction: 'ease',
    // Ensure touch users get full photo area for swiping
    zIndex: -1,
  },

  // Make sure nav buttons don't appear on touch screens after a tap.
  '_hoverMouse': {
    _hoverNotDisabled: {
      '& > [data-c11n-component="PhotoCarousel.NavControls"]': {
        opacity: 1,
        zIndex: 1,
      },
    },
  },

  '&:has(a:focus-within > [data-c11n-component="PropertyCard.Photo"])': {
    boxShadow: 'focus',
  },
});
